<template>
  <AkAlert type="neutral">
    <i18n-t
      keypath="For it to be automatically translated into all the languages available on Ankorstore, your product must be entered in {0}."
    >
      <strong data-testid="bannerBrandLanguageName">
        {{ brandLanguageLabel }}
      </strong>
    </i18n-t>
  </AkAlert>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';
import { Brand } from '@monolith/legacy/types/api/brand';
import { AkAlert } from '@ankorstore/design-system';

export default defineComponent({
  name: 'BannerBrandLanguage',
  components: { AkAlert },
  props: {
    brand: {
      type: Object as PropType<Brand>,
      required: true,
    },
  },
  computed: {
    brandLanguageLabel(): string {
      switch (this.brand.original_language) {
        case 'da':
          return this.$t('Danish');
        case 'de':
          return this.$t('German');
        case 'en':
          return this.$t('English');
        case 'es':
          return this.$t('Spanish');
        case 'fi':
          return this.$t('Finnish');
        case 'fr':
          return this.$t('French');
        case 'it':
          return this.$t('Italian');
        case 'nl':
          return this.$t('Dutch');
        case 'pt':
          return this.$t('Portuguese');
        case 'sv':
          return this.$t('Swedish');
        default:
          return this.brand.original_language;
      }
    },
  },
});
</script>
